import React from "react";
import { useGlobalContext } from "../../utils/globalContext";

const Policy = ({ content }) => {
  const { Trans } = useGlobalContext();

  return (
    <div id="policy">
      <h1 className="title">{content.title}</h1>

      <div className="content">
        {content.privacySection.map((section, i) => (
          <div key={i} className={`section ${section.hasSpacing ? "spacing" : ""}`}>
            <div className="title">{section.title}</div>
            <div className="paragraphs">
              {section.privacyParagraphs.map((paragraph, paragraphIndex) => (
                <Trans key={paragraphIndex}>
                  <p className={`paragraph ${paragraph.isCaption ? "caption" : ""}`}>{paragraph.content}</p>
                </Trans>
              ))}
            </div>
          </div>
        ))}
        <p className="date">{content.date}</p>
      </div>
    </div>
  );
};

export default Policy;
